import { atom } from 'jotai'
import { Quote } from 'types/payments'
import { ConvertWallet } from 'types/types'
import { ConvertStep } from 'types/walletActions'
import { ConvertDetailsFormData } from '../schemas/convertDetailsSchema'

export const convertStepAtom = atom<ConvertStep>(ConvertStep.DETAILS)
convertStepAtom.debugLabel = 'convert-step'

export const convertFromWalletAtom = atom<ConvertWallet>()
convertFromWalletAtom.debugLabel = 'convert-from-wallet'

export const convertToWalletAtom = atom<ConvertWallet>()
convertToWalletAtom.debugLabel = 'convert-to-wallet'

export const quoteEstimateAtom = atom<Quote>()
quoteEstimateAtom.debugLabel = 'quote-estimate'

export const quoteAtom = atom<Quote>()
quoteAtom.debugLabel = 'quote'

export const convertFormValuesAtom = atom<ConvertDetailsFormData>()
convertFormValuesAtom.debugLabel = 'convert-form-values'
